import styled from 'styled-components';

import CloseIcon from '#/assets/CloseIcon';

import { cFFFFFF } from '#/colors';

const CloseButton = styled.button.attrs({
  'aria-label': 'close',
  children: <CloseIcon size={16} />,
})`
  color: ${cFFFFFF};
  position: absolute;
  margin: auto 0px;
  top: 0px;
  bottom: 0px;
  right: 8px;

  display: grid;
  align-content: center;

  opacity: 0.5;
  border: none;
  background: none;

  &:hover {
    opacity: 1;
  }
`;

export default CloseButton;
